module.exports = __webpack_public_path__ + "static/media/lanuza.4525e2b2.png";